module.exports = __webpack_public_path__ + "static/carrot-89e92ed59dfb24463ae9cd1f4eaaf37d.png";